// 仪表盘对外链接路由
const routes = [
    {
		path: "/dashboardlink/:id",
		component: () => import(/* webpackChunkName: "login" */ '@/views/engine/design/dashboard/design/release/link-dashboard.vue'),
		meta: {
			title: "仪表盘"
		}
	},
	{
		path: "/appdashboard/:id",
		component: () => import(/* webpackChunkName: "login" */ '@/views/engine/design/dashboard/design/release/link-dashboard.vue'),
		meta: {
			title: "仪表盘"
		}
	}
]
export default routes;